import { Add } from '@mui/icons-material'
import { IconButton, Stack, Tooltip } from '@mui/material'

import { useTexts } from './useTexts'

import { form } from '../../../../../../formState'

interface Props {
  disabled?: boolean
  onOpenDialog: () => void
}

export function Header(props: Props) {
  const { onOpenDialog, disabled } = props

  const texts = useTexts()

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <form.SectionTitle>{texts.title}</form.SectionTitle>
      <Tooltip title={texts.addTooltip(disabled)}>
        {/* A disabled element does not fire events. */}
        {/* Tooltip needs to listen to the child element's events to display the title. */}
        <span>
          <IconButton onClick={onOpenDialog} disabled={disabled} size="small">
            <Add />
          </IconButton>
        </span>
      </Tooltip>
    </Stack>
  )
}
